// =============================================================
// Guarda de consistência da sessão.
//
// PROBLEMA que resolve: o `idcliente` que o app envia para a API vem de
// `localStorage.sessionCodidcliente`, mas a autenticação vem do JWT em
// `localStorage.sessionToken`. Se as duas chaves ficarem em desacordo, o app
// manda uma requisição com `idcliente` diferente do token — cross-tenant. Isso
// acontece, por exemplo, com DUAS abas do mesmo site logadas em contas
// diferentes: o localStorage é compartilhado, então o login de uma sobrescreve
// o `sessionCodidcliente` da outra. Foi flagrado pelo Middleware.TenantGuard
// (token_idcliente=33, query idcliente=43).
//
// O token é a FONTE DE VERDADE (é o que a API valida). Esta guarda força
// `sessionCodidcliente` a sempre bater com o `idcliente` do token. Com isso o
// front nunca envia idcliente divergente — pré-requisito para ligar o
// TENANT_GUARD_ENFORCE no backend sem quebrar o app.
//
// NÃO mexe em `sessionloja`: trocar de loja é legítimo e altera a loja sem
// reemitir o token (o guard do backend também não força idloja).
// =============================================================

// Decodifica o payload (2ª parte) do JWT. base64url -> base64 antes do atob.
function lerClaims(token) {
  try {
    const parte = token.split('.')[1];
    if (!parte) return null;
    const b64 = parte.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

// Se `sessionCodidcliente` estiver diferente do idcliente do token, corrige a
// partir do token. Retorna true se houve correção.
export function sincronizarClienteComToken() {
  const token = localStorage.getItem('sessionToken');
  if (!token) return false;
  const claims = lerClaims(token);
  if (!claims || claims.idcliente == null) return false;

  const tokenCli = String(claims.idcliente);
  if (!tokenCli || tokenCli === '0') return false;

  if (localStorage.getItem('sessionCodidcliente') !== tokenCli) {
    localStorage.setItem('sessionCodidcliente', tokenCli);
    return true;
  }
  return false;
}

// Instala a guarda: sincroniza no boot e reage a mudanças de sessão vindas de
// OUTRA aba (evento `storage`). Se a identidade da sessão mudou em outra aba,
// recarrega esta — assim o app inteiro (telas + requisições) passa a operar de
// forma consistente com a sessão atual do localStorage compartilhado, em vez de
// misturar token de uma conta com idcliente de outra.
// Retorna a função de limpeza do listener.
export function instalarSessaoGuard() {
  sincronizarClienteComToken();

  const onStorage = (e) => {
    // e.key === null quando o localStorage é limpo por inteiro (clear()).
    if (e.key === 'sessionToken' || e.key === 'sessionCodidcliente' || e.key === null) {
      sincronizarClienteComToken();
      // Só recarrega quando o TOKEN em si mudou (troca/saída de conta em outra
      // aba). Correção só do sessionCodidcliente não precisa de reload — a
      // sincronização acima já deixou o localStorage coerente para as próximas
      // requisições.
      if (e.key === 'sessionToken' || e.key === null) {
        window.location.reload();
      }
    }
  };

  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}
